export enum PAYMENT_TYPE {
  SPLIT = 'split',
  SPLIT_AMOUNT = 'split.amount',
}

export enum PROVIDER {
  STRIPE = 'STRIPE',
  ADYEN = 'ADYEN',
}
